var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKprsr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFFFFF",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M452.608,92.3l-93.882,93.882h36.911c12.87,0,23.273,10.426,23.273,23.273c0,12.847-10.403,23.273-23.273,23.273h-93.091 c-3.025,0-6.051-0.628-8.89-1.792c-5.702-2.351-10.24-6.889-12.591-12.591c-1.187-2.839-1.792-5.865-1.792-8.89v-93.091 c0-12.847,10.403-23.273,23.273-23.273s23.273,10.426,23.273,23.273v36.911L419.7,59.392C375.273,22.365,318.208,0,256,0 C114.851,0,0,114.851,0,256c0,62.208,22.342,119.273,59.392,163.7l93.882-93.882h-36.911c-12.87,0-23.273-10.426-23.273-23.273 s10.403-23.273,23.273-23.273h93.091c3.025,0,6.051,0.628,8.89,1.792c5.702,2.351,10.24,6.889,12.591,12.591 c1.164,2.839,1.792,5.865,1.792,8.89v93.091c0,12.847-10.403,23.273-23.273,23.273s-23.273-10.426-23.273-23.273v-36.911 L92.3,452.608C136.704,489.635,193.792,512,256,512c141.149,0,256-114.851,256-256C512,193.792,489.635,136.727,452.608,92.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKprsr);
export default __webpack_public_path__ + "static/media/kprsr.cc3a85dcfc997dc8745f053710d14e45.svg";
export { ForwardRef as ReactComponent };